import { render, staticRenderFns } from "./SitchCheckbox.vue?vue&type=template&id=d5e3f0f8&scoped=true&"
import script from "./SitchCheckbox.vue?vue&type=script&lang=ts&"
export * from "./SitchCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./SitchCheckbox.vue?vue&type=style&index=0&id=d5e3f0f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e3f0f8",
  null
  
)

export default component.exports